import {ImageExportType} from '@wandb/common/util/panelExport';
import React, {useCallback} from 'react';
import {Dropdown} from 'semantic-ui-react';

import {getPanelSpec, isExportableAs} from '../../util/panels';
import {Icon} from '../Icon';
import {
  StyledDropdownText,
  StyledMenuItem,
  StyledMenuItemContainer,
} from './PanelActions.style';
import {ExportType} from './PanelActionsMenu';
interface PanelExportMenuProps {
  ref: React.RefObject<HTMLElement>;
  panelSpec: ReturnType<typeof getPanelSpec>;
  handleClose(): void;
  setExportType(type: ExportType): void;
  setImageExportType(imageType: ImageExportType): void;
}

export const PanelExportMenu = React.forwardRef<
  HTMLElement,
  PanelExportMenuProps
>(({panelSpec, handleClose, setExportType, setImageExportType}, ref) => {
  const onExportImageClick = useCallback(
    (imageType: ImageExportType) => {
      setExportType(ExportType.Image);
      setImageExportType(imageType);
      handleClose();
    },
    [handleClose, setExportType, setImageExportType]
  );

  const onExportClick = useCallback(
    (exportType: ExportType) => {
      setExportType(exportType);
      handleClose();
    },
    [handleClose, setExportType]
  );

  return (
    <StyledMenuItemContainer>
      <Dropdown
        className="panel-action"
        item
        trigger={
          <StyledMenuItem>
            <Icon name="download" /> Download
            <Icon name="chevron-next" />
          </StyledMenuItem>
        }
        icon={<></>}>
        <Dropdown.Menu
          style={{
            top: 40,
            left: 75,
          }}>
          {isExportableAs(panelSpec, 'csv') && (
            <Dropdown.Item
              className="panel-action"
              title="CSV"
              onClick={() => onExportClick(ExportType.CSV)}
              text="CSV">
              <StyledDropdownText>CSV</StyledDropdownText>
            </Dropdown.Item>
          )}
          {isExportableAs(panelSpec, 'image') && (
            <>
              <Dropdown.Item
                className="panel-action"
                onClick={() => onExportImageClick(ImageExportType.PNG)}>
                <StyledDropdownText>PNG</StyledDropdownText>
              </Dropdown.Item>
              <Dropdown.Item
                className="panel-action"
                onClick={() => onExportImageClick(ImageExportType.PDF)}>
                <StyledDropdownText>PDF</StyledDropdownText>
              </Dropdown.Item>
              <Dropdown.Item
                className="panel-action"
                onClick={() => onExportImageClick(ImageExportType.SVG)}>
                <StyledDropdownText>SVG</StyledDropdownText>
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </StyledMenuItemContainer>
  );
});
